import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { ExecutionResult } from '@rossum/api-client/rulesExecutionLogs';
import { Chip, Stack } from '@rossum/ui/material';

type ExecutionResultColumnProps = {
  executionResult: ExecutionResult;
};

export const ExecutionResultColumn = ({
  executionResult,
}: ExecutionResultColumnProps) => {
  const intl = useIntl();

  const getColor = useMemo(
    () => () => {
      switch (executionResult) {
        case 'success':
          return 'success';
        case 'failure':
          return 'error';
        case 'partial_success':
          return 'warning';
        default:
          return 'default';
      }
    },
    [executionResult]
  );

  return (
    <Stack direction="row" alignItems="center" width="100%">
      <Chip
        label={intl.formatMessage({
          id: `features.rulesExecutionLogs.status.${executionResult}`,
        })}
        size="small"
        color={getColor()}
      />
    </Stack>
  );
};
